module.exports = __webpack_public_path__ + "assets/burger.d0a0cb49.svg";